import { useEffect } from "react";

export default function Title({ title }) {
  useEffect(() => {
    document.title = title ? `${title} | Hubert's HUB` : "Hubert's HUB";
  }, [title]);
  return null;
}
